<template>
  <div class="manager-fallback">
    <div class="panel-header">
      <h3 class="panel-header__title">打底广告管理</h3>
      <span class="panel-header__subtitle">FALLBACK AD MANAGEMENT</span>
      <a class="panel-header__export" v-if="dataUrls" :href="dataUrls">导出</a>
    </div>
    <div class="panel-content">
      <h3 class="panel-content__title">
        打底广告管理
        <el-button type="primary" class="fr" @click="add_order">
          <b>+&nbsp;</b>
          <i>新增打底</i>
        </el-button>
      </h3>
      <div class="panel-content__select-list">
        <!-- <el-input class="mr10" v-model="search.ad_name" placeholder="请输入打底广告名称"></el-input> -->
        <!-- <el-button class="mb20" @click="searchData">搜索</el-button> -->
        <div class="fr mr20" v-if="user.id_tag !== 9">
          <el-button @click="batchStartAndStopAd('batchStart', ids)">批量开始</el-button>
          <el-button class="is-warning" @click="batchStartAndStopAd('batchStop', ids)">批量暂停</el-button>
        </div>
      </div>
      <div class="panel-content__table-wrap">
        <ny-table
          class="tableBox mt20"
          :page="fallback.page"
          :fixedColumns="{}"
          selection
          @select-change="handleSelectChange"
          :widthColumns="{id: 80, order_name: 260, time_str: 180, status_msg: 100, updated_at: 150 }"
          :slot-columns="['order_name', 'status_msg']"
          @size-change="sizeChange"
          @current-change="currentChange"
          @cell-click="handleCellClick"
        >
          <template slot="order_name" slot-scope="{ row }">
            <span class="panel-content__table-link">{{row.order_name }}</span>
          </template>
          <el-table-column label="开启" align="center" fixed="right" width="60">
            <template slot-scope="scope">
              <template>
                <up-switch
                  :value="scope.row.status === 1"
                  @change="timeOut(scope.row, stopStatuses)"
                ></up-switch>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button @click="edit(scope.row)" size="small" class="is-edit">编辑</el-button>
              <el-button size="small" class="is-view" @click="readInfo(scope.row)">查看</el-button>
              <el-button @click="stop(scope.row, scope.row.id)" size="small" class="is-remove">停止</el-button>
              <el-button size="small" @click="coypInfo(scope.row)">复制</el-button>
            </template>
          </el-table-column>
        </ny-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { NyTable } from '@/global/components';
import { tip } from '@/global/util/util';

export default {
  components: {
    NyTable
  },
  data() {
    this.stopStatuses = ['排期已过']
    return {
      data: {},
      page: {
        headers: {},
        data: [],
        pageSize: 10,
        currentPage: 1,
        total: 0,
        loading: false
      },
      search: {

      },
      dataUrls: ''
    };
  },
  async created() {
    this.platform = this.$router.currentRoute.meta.platform // 定义标识当前系统的常量
    this.getList()
  },
  computed: {
    ...mapGetters({
      orderManage: 'orderManage',
      fallback: 'fallbackAd/fallback',
      userid: 'login/userid',
      user: 'login/user'
    })
  },
  methods: {
    ...mapActions('fallbackAd', ['getFallbackList', 'batchStop', 'batchStart']),

    getList({ currentPage, pageSize } = {}) {
      let params = {
        currentPage,
        pageSize,
        ad_name: this.search.ad_name
      }
      this.getFallbackList(params)
    },
    searchData() {
      this.page.currentPage = 1
      this.page.pageSize = 10
      this.getFallbackList({
        ad_name: this.search.ad_name
      });
    },
    handleSelectChange(selection) {
      this.ids = selection.map(v => v.id)
    },
    sizeChange({ currentPage, pageSize } = {}) { // 当表格显示条数发生变化是触发的函数
      this.getList({ currentPage, pageSize });
    },
    currentChange({ currentPage, pageSize } = {}) { // 当页面发生变化时触发的函数
      this.getList({ currentPage, pageSize });
    },
    add_order() {
      this.$router.push({ name: 'fallbackAdd', params: { media: this.orderManage.mediaType } })
    },
    stop(row, id) {
      this.$confirm('“确认永久停止此计划？”', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('fallbackAd/stopFallbackAd', id).then((data) => {
          if (data && data.code === 1) {
            this.$message({
              type: 'success',
              message: '已停止!'
            });
            this.getList();
          }
        });
      });
    },
    async timeOut(row, stopStatuses) {
      /*   if (row.status !== 2 && stopStatuses.includes(row.status_msg)) {
          return tip(`计划状态为“${row.status_msg}”的计划无法开启！`);
        } */
      const type = row.status === 0 ? 'batchStart' : 'batchStop'
      await this[type]({
        ids: [row.id]
      }).then((data) => {
        const [, result] = data
        if (result.code === 1) {
          this.getFallbackList();
        } else {
          this.$message(data.msg)
        }
      })
    },
    async batchStartAndStopAd(type, ids) {
      if (ids.length < 1) { return tip('请至少选择一个计划进行批量操作') }
      this[type]({ ids: ids }).then(res => {
        const [, result] = res
        if (result.code === 1) {
          this.$message({
            type: 'success',
            message: '批量操作成功'
          })
          this.getFallbackList()
        } else {
          return tip('批量操作失败')
        }
      })
    },
    handleCellClick({ row, column, cell }) {
      if (['order_name'].indexOf(column.property) > -1) {
        // this.order.value = column.property
        // this.filterValue = row[column.property]
        // this.searchData()
        this.$router.push({ path: '/advertiseList', query: { name: row[column.property], value: 'order_name' } })
      }
    },
    readInfo(row) {
      this.$router.push({ name: 'fallbackEdit', params: { id: row.id, type: 'show' } });
    },
    edit(row) {
      this.$router.push({ name: 'fallbackEdit', params: { id: row.id, type: 'edit' } });
    },
    coypInfo(row) {
      this.$router.push({ name: 'fallbackEdit', params: { id: row.id, type: 'copy' } });
    }
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.manager-fallback {
  .panel-content__table-wrap {
    margin-top: 15px;
  }
  .input_sm {
    .el-select {
      width: 134px;
    }
  }
  .el-tabs__item {
    text-align: center;
    width: 140px;
  }
  .selectBox {
    .wid210 {
      width: 210px;
    }
  }
  .tableBox {
    margin-top: 15px;
  }
}
</style>
